export default __webpack_public_path__ + "static/media/nashawn.86a15cf2.jpg";